import React from "react";
import logo from "../assets/logo.png";

function Header() {
  const headerStyle = {
    backgroundColor: "black",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "75px",
    padding: "10px 0",
    width: "100%",
  };

  return (
    <header style={headerStyle}>
      <a href="https://www.floorkitchenresource.com/" rel="noopener noreferrer">
        <img src={logo} alt="Logo" style={{ height: "60px" }} />
      </a>
    </header>
  );
}

export default Header;
